import Vue from 'vue'
import { StreamBarcodeReader } from 'vue-barcode-reader'

Vue.component('stream-barcode-reader', StreamBarcodeReader)
